module.exports = __webpack_public_path__ + "img/7.24deab67.jpg";